export enum DateTimeFormatTypes {
  DATE_TIME_FULL = 'YYYY-MM-DD HH:mm:ss',
}
